var BlockBlog = {
	init:function(){
		$(window).resize(function(){
			BlockBlog.resize();	
		});

		BlockBlog.resize();
	},
	resize:function(){
		
		var _carousel = $(".block-blog .blog-list");

		if (_carousel.hasClass('slick-initialized')) {
			_carousel.slick('unslick');
		}

		//var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

		var _slides_to_show = 1;
		var els = document.querySelectorAll(".block-blog");

		Array.prototype.forEach.call(els, function(el) {
			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));			
		});


		_carousel.slick({
			arrows:true, 
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: _slides_to_show,
			focusOnSelect: true,
			touchThreshold:500,
			nextArrow:_carousel.parent().find(".arrow-container.next .arrow")
		});	
		
	}
}

$(window).load(function(){
	if($(".block-blog").length){
		BlockBlog.init();
	}
})